import React from 'react';

const FormInput = ({ label, id, type, classes, name, accept, handleChange }) => {

  return (
      <div className="form-group mb-4">
        <label className="font-weight-bold lead" htmlFor={id}>{label}</label>
        <input 
          type={type} 
          id={id}
          className={classes}
          name={name} 
          onChange={(item) => handleChange(item)}
          accept={accept}
          // multiple
        />
      </div>
  );
}

export default FormInput;